import React from 'react';
import { Badge } from 'framework/ui/mui-builder';
import { VACANCY_STATUS, VACANCY_STATUS_OPTIONS } from 'domain/shared/newVacancy';
import { SxProps } from '@mui/material';

type LabelStatusProps = {
  status: keyof typeof VACANCY_STATUS;
  sx?: SxProps;
};

const LabelStatus = ({ status, sx }: LabelStatusProps) => {
  const colorFunc = () => {
    if (status === VACANCY_STATUS.OPEN) {
      return 'success';
    }

    if (status === VACANCY_STATUS.REQUIRES_REVIEW || status === VACANCY_STATUS.CANCELLATION_REQUESTED) {
      return 'warning';
    }

    if (status === VACANCY_STATUS.EXPIRED) {
      return 'error';
    }

    return 'default';
  };

  return (
    <Badge
      sx={{
        marginLeft: '0',
        right: 0,
        minWidth: 80,
        paddingX: '10px',
        height: 25,
        ...sx,
      }}
      color={colorFunc()}
    >
      {VACANCY_STATUS_OPTIONS[status]}
    </Badge>
  );
};

export default LabelStatus;
